import React from 'react';
import './HowToPlay.css';

const HowToPlay = () => {
  return (
    <section className="how-to-play" id="how-to-play" data-aos="fade-up">
      <div className="container">
        <h2 className="how-to-play__title" data-aos="fade-down" data-aos-delay="200">
          How to Play
        </h2>
        <div className="how-to-play__grid">
          <div className="how-to-play__content" data-aos="fade-right" data-aos-delay="300">
            <div className="how-to-play__text-wrapper">
              <p className="how-to-play__text">
                Learning to play CyberLingo is easy! The objective is to be the 
                last player with their systems secure. Each turn, you'll draw cards, 
                play actions to bolster your defenses or attack opponents, and react 
                to events.
              </p>
              <p className="how-to-play__text">
                The game combines strategy, a bit of luck, and a whole 
                lot of fun. Perfect for game nights with friends or family!
              </p>
              
              <div className="how-to-play__features">
                <div className="how-to-play__feature">
                  <span className="material-icons how-to-play__feature-icon">play_circle</span>
                  <div>
                    <h4 className="how-to-play__feature-title">Quick Start</h4>
                    <p className="how-to-play__feature-text">Learn the basics in under 5 minutes</p>
                  </div>
                </div>
                <div className="how-to-play__feature">
                  <span className="material-icons how-to-play__feature-icon">psychology</span>
                  <div>
                    <h4 className="how-to-play__feature-title">Strategic Gameplay</h4>
                    <p className="how-to-play__feature-text">Outsmart your opponents with clever tactics</p>
                  </div>
                </div>
                <div className="how-to-play__feature">
                  <span className="material-icons how-to-play__feature-icon">emoji_events</span>
                  <div>
                    <h4 className="how-to-play__feature-title">Win Conditions</h4>
                    <p className="how-to-play__feature-text">Be the last secure system standing</p>
                  </div>
                </div>
              </div>

              <p className="how-to-play__cta">
                Ready to dive in? Grab your deck, gather your friends, and prepare 
                for a battle of wits in the digital realm!
              </p>
            </div>
          </div>
          
          <div className="how-to-play__video-container" data-aos="fade-left" data-aos-delay="400">
            <div className="how-to-play__video how-to-play__video--shorts">
              <iframe 
                src="https://www.youtube.com/embed/wStOPX4VHYM"
                title="How to play CyberLingo"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="how-to-play__iframe"
              ></iframe>
            </div>
            <p className="how-to-play__video-caption">
              Watch our quick tutorial to see the game in action!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowToPlay;